import { SizeType } from 'antd/lib/config-provider/SizeContext';
import styled from 'styled-components';
import { Input } from 'UI';

const sizeToHeight: Record<NonNullable<SizeType>, string> = {
  small: '24px',
  middle: '32px',
  large: '40px',
};

const sizeToRadius: Record<NonNullable<SizeType>, string> = {
  small: '12px',
  middle: '16px',
  large: '20px',
};

const sizeToWidth: Record<NonNullable<SizeType>, string> = {
  small: '200px',
  middle: '260px',
  large: '300px',
};

const getReferenceInputWidth = (expandable = false, size?: SizeType) => {
  if (expandable) {
    return undefined;
  }
  return size ? sizeToWidth[size] : '330px';
};

export const SReferenceInput = styled(Input)<{ expandable?: boolean; size?: SizeType }>`
  height: ${({ size }) => (size ? sizeToHeight[size] : '45px')};
  width: ${({ expandable, size }) => getReferenceInputWidth(expandable, size)};
  border-radius: ${({ size }) => (size ? sizeToRadius[size] : '23px')};
`;
